interface MarketItem {
  id: number;
  aid: number;
  text: string;
  value: number;
  change: {
    id: number;
    aid: number;
    text: string;
    value: number;
  };
}

export function sortItems(items: MarketItem[]) {
  return items.toSorted((a, b) => {
    const x = a.value;
    const y = b.value;
    return x === y ? 0 : x < y ? 1 : -1;
  });
}
